import React from "react";
import { motion } from "framer-motion";
import { CalendarIcon, UserCheckIcon, ClockIcon, RepeatIcon, AwardIcon, BoxIcon } from "lucide-react";
interface Pain {
  icon: BoxIcon;
  title: string;
  text: string;
}
const PAINS: Pain[] = [{
  icon: CalendarIcon,
  title: 'Sentís que improvisás tus clases',
  text: 'Llegás al estudio pensando qué ejercicios hacer, repetís secuencias o cambiás el plan sobre la marcha porque no tenés una estructura clara.'
}, {
  icon: UserCheckIcon,
  title: 'Te preocupa no saber adaptar un ejercicio',
  text: 'Cuando aparece una embarazada, un alumno con dolor lumbar o alguien con una limitación, dudás sobre qué hacer y terminás improvisando.'
}, {
  icon: ClockIcon,
  title: 'Pasás más tiempo preparando las clases que enseñando',
  text: 'Horas buscando ejercicios en Instagram, YouTube o anotaciones viejas para terminar armando una sola clase.'
}, {
  icon: RepeatIcon,
  title: 'Sentís que repetís siempre lo mismo',
  text: 'Querés que tus alumnos progresen y disfruten las clases, pero cada vez cuesta más encontrar ideas nuevas.'
}, {
  icon: AwardIcon,
  title: 'Querés sentirte más segura dando clases',
  text: 'Sabés que podrías ofrecer mucho más si tuvieras un sistema claro para planificar, adaptar y enseñar.'
}];
export function PainPoints() {
  return <section className="w-full bg-beige py-16 sm:py-20" data-id="element-127" data-mp="23r56udlqpj3p">
      <div className="mx-auto max-w-6xl px-6" data-id="element-128" data-mp="23trcg7p2loja">
        <div className="mx-auto max-w-2xl text-center" data-id="element-129" data-mp="1g2ubfpytcbmt">
          
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-130" data-mp="1b2zjdj3axg06">
            ¿Te pasa alguna de estas situaciones?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-brown-dark/70 sm:text-lg" data-id="element-131" data-mp="1p0ee93cbqfzj">
            Si preparar cada clase te genera dudas, este sistema te devuelve estructura y seguridad.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-132" data-mp="2vj2udhkwm886">
          {PAINS.map(({
          icon: Icon,
          title,
          text
        }, i) => <motion.article key={title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className="rounded-2xl border border-brown-light/15 bg-white p-7 shadow-sm" data-id="element-133" data-mp="1t79col36jmu4" data-mpi={i}>
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-beige-deep text-brown-light" data-id="element-134" data-mp="1agi7zwu50km2">
                <Icon className="h-6 w-6" strokeWidth={1.75} data-id="element-135" data-mp="1jfc1hec68uve" />
              </div>
              <h3 className="font-serif text-xl font-semibold leading-snug text-brown-dark" data-id="element-136" data-mp="1jd90y0de7jcf">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-brown-dark/70" data-id="element-137" data-mp="qr7tuna1i7q2">
                {text}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}